import PropTypes from 'prop-types';
import React from 'react';
import { EVENT_ICONS } from './EventStyles';

class EventIcon extends React.Component {
  render() {
    const stackSize = `fa-stack fa-${this.props.size}`;
    const label = `fa ${EVENT_ICONS[this.props.eventType]} fa-stack-1x`;
    return (
      <span className={stackSize} aria-hidden="true">
        <i className="fa fa-square-o fa-stack-2x" />
        <i className={label} />
      </span>
    );
  }
}
EventIcon.propTypes = {
  eventType: PropTypes.string.isRequired,
  size: PropTypes.string,
};
EventIcon.defaultProps = {
  size: 'lg',
};

export default EventIcon;



// WEBPACK FOOTER //
// src/routes/tours/components/EventIcon.js